/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiRequestOptions } from './ApiRequestOptions';

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;

export const OpenAPI: OpenAPIConfig = {
  BASE: '',
  VERSION: '1.0',
  WITH_CREDENTIALS: false,
  CREDENTIALS: 'include',
  TOKEN: async () => {
    const tokenString = localStorage.getItem('token');
    if (tokenString) {
      const tokenResponse = JSON.parse(tokenString);
      return tokenResponse?.accessToken || '';
    }
    return '';
  },
};

export type ErrorRoutes = {
  400?: string;
  401?: string;
  403?: string;
  500?: string;
};

export type ErrorHandler = (errorCode: number, errorText?: string) => void;

export type OpenAPIConfig = {
  BASE: string;
  VERSION: string;
  WITH_CREDENTIALS: boolean;
  CREDENTIALS: 'include' | 'omit' | 'same-origin';
  TOKEN?: string | Resolver<string> | undefined;
  ERROR_ROUTES?: ErrorRoutes;
  ON_ERROR?: ErrorHandler;
};
